<template>
    <v-slider v-model="score" v-bind="{ ...$attrs, color, trackColor, trackFillColor }" @change="emit" />
</template>

<script>
export default {
    props: {
        value: { type: Number, default: 0 },
        color: { type: String, default: "secondary" },
        trackColor: { type: String, default: "secondary" },
        trackFillColor: { type: String, default: "grey lighten-5" },
    },
    data: () => ({
        score: 0,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.score = 100 - (this.value || 0);
        },
        emit() {
            this.$emit("input", 100 - (this.score || 0));
        },
    },
};
</script>

<style>
</style>